/**
 * Whether the homepage banner search bar is on screen (below the sticky
 * header). Written by `BannerGallery.vue`, read by `Navbar.vue` to reveal the
 * navbar search once the banner search scrolls away (KFT-4035 item 3).
 *
 * Defaults to `true` so SSR and hydration keep the navbar search hidden on the
 * homepage, exactly as before; it only changes on the client after mount.
 */
export const useHomepageBannerSearchVisibility = () =>
  useState<boolean>('homepage-banner-search-visible', () => true)
